import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './css/loading.css';
import './css/fonts.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const rootElement = document.getElementById('root');
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM.render(
  <BrowserRouter baseUrl={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement,
);
